export { AmplifyAngularModule } from './src/aws-amplify-angular.module';
export { AmplifyIonicModule } from './src/aws-amplify-ionic-module';
export { AmplifyService, AmplifyModules } from './src/providers';

console.warn(
	'`aws-amplify-angular` has been deprecated and will be removed in a future major version of `aws-amplify`. Please visit https://ui.docs.amplify.aws/ for more info on Amplify UI.'
);
